export default __webpack_public_path__ + "static/media/exterior1_2019.02f17c0e.jpeg";